import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { ClipCard } from "../components/ClipCard";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Film, Sparkles } from "lucide-react";

export default function MyClips() {
  const navigate = useNavigate();
  const { isPaid } = useAuth();
  const [clips, setClips] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const load = () => api.get("/clips").then((r) => { setClips(r.data.clips || []); setLoaded(true); }).catch(() => setLoaded(true));
  useEffect(load, []);

  return (
    <div className="min-h-screen grain">
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="flex items-center justify-between mb-6">
          <div>
            <div className="inline-flex px-2.5 py-1 rounded-full bg-amber-500/10 text-amber-400 border border-amber-500/30 text-[10px] font-mono uppercase tracking-widest mb-2">Paid Pro</div>
            <h1 className="font-display text-3xl font-bold">My Clips</h1>
          </div>
          <Button onClick={() => navigate("/workspace")} className="bg-amber-500 hover:bg-amber-400 text-zinc-950 font-bold"><Sparkles className="w-4 h-4 mr-1.5" /> New Clips</Button>
        </div>

        {loaded && clips.length === 0 ? (
          <div className="text-center py-24" data-testid="no-clips">
            <Film className="w-12 h-12 text-zinc-700 mx-auto mb-4" />
            <p className="text-zinc-400 mb-6">{isPaid ? "No clips yet. Head to the workspace to generate your first clips." : "Subscribe to generate AI clips."}</p>
            <Button onClick={() => navigate(isPaid ? "/workspace" : "/pricing")} className="bg-amber-500 hover:bg-amber-400 text-zinc-950 font-bold">
              {isPaid ? "Open Workspace" : "View Plans"}
            </Button>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="clips-grid">
            {clips.map((c) => <ClipCard key={c.id} clip={c} onChange={load} />)}
          </div>
        )}
      </div>
    </div>
  );
}
